import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { logError } from 'lib/sentry/logError';
import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

import {
  SessionSummary,
  TranscriptAnalysis,
} from 'features/sessions/config/types';
import { useSessionsQueryActions } from 'features/sessions/hooks/useSessionsQueryActions';

import { showErrorToast } from 'shared/components/Toast';

export const useSessionNoteInsightsUpdateMutation = () => {
  const { request } = useMutationHTTPRequest();
  const { sessionId } = useParams();
  const { getSessionById, updateSession } = useSessionsQueryActions();

  return useMutation<SessionSummary, unknown, TranscriptAnalysis[]>(
    (transcriptAnalysis) => {
      return request({
        url: `/api/coach/coaching-sessions/${sessionId}/transcript/insights/edit`,
        body: {
          transcriptAnalysis,
        },
      });
    },
    {
      onSuccess: (sessionSummary) => {
        const prevSession = getSessionById(sessionId!);

        if (!prevSession) {
          return;
        }

        updateSession(sessionId!, {
          ...prevSession,
          ...sessionSummary,
        });
      },
      onError: (err) => {
        showErrorToast(
          'Failed to update session note. Please try again later.'
        );
        logError(err);
      },
    }
  );
};
